import { hasInMeta } from 'Utils/router';
import store from 'Store';
import * as routerUtils from 'Utils/router';
import set from 'Utils/lodash.set';

export function requestAuth(to, from, next) {
  // Redirect to sign in page
  const redirectRoute = { name: 'sign-in' };
  // Set redirect query if router don't have meta skipRedirectToRoute
  if (!routerUtils.hasInMeta(to, 'skipRedirectToRoute')) {
    set(redirectRoute, 'query.redirect', to.fullPath);
    // if it's not a first route in session
    if (from.name) {
      // add from to query
      redirectRoute.query.from = from.path;
    } else {
      // otherwise make replace current query request
      redirectRoute.replace = true;
    }
  }
  next(redirectRoute);
}

export function resolveAuth(to, from, next) {
  const isRequiresAuth = hasInMeta(to, 'requiresAuth');
  const isRequiresAccreditation = hasInMeta(to, 'requiresAccreditation');
  const isLoggedIn = store.getters['login/isLoggedIn'];
  if ((isRequiresAuth || isRequiresAccreditation) && !isLoggedIn) {
    requestAuth(to, from, next);
    return Promise.reject(new Error('Authorization Required'));
  }
  return Promise.resolve();
}
